var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartSimpleFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,3V21c0,1.66-1.34,3-3,3s-3-1.34-3-3V3c0-1.66,1.34-3,3-3s3,1.34,3,3Zm6,3c-1.66,0-3,1.34-3,3v12c0,1.66,1.34,3,3,3s3-1.34,3-3V9c0-1.66-1.34-3-3-3ZM3,12c-1.66,0-3,1.34-3,3v6c0,1.66,1.34,3,3,3s3-1.34,3-3v-6c0-1.66-1.34-3-3-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSimpleFull);
export default __webpack_public_path__ + "static/media/chart-simple-full.5923e840d8b59f3e81223a9d636f4930.svg";
export { ForwardRef as ReactComponent };